import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Form, Input, InputNumber, Button, Card, Typography, message, Select } from 'antd'
import { createProduct } from '../../services/product'
import { getCurrencies } from '../../services/config'
import type { CurrencyOption } from '../../services/config'

const { Title } = Typography
const { TextArea } = Input

interface ProductForm {
  name: string
  description?: string
  price: number
  currency: string
}

export default function ProductCreate() {
  const [loading, setLoading] = useState(false)
  const [currencyOptions, setCurrencyOptions] = useState<CurrencyOption[]>([])
  const [defaultCurrency, setDefaultCurrency] = useState('USD')
  const [form] = Form.useForm<ProductForm>()
  const navigate = useNavigate()

  useEffect(() => {
    getCurrencies().then((res) => {
      setCurrencyOptions(res.data.currencies)
      setDefaultCurrency(res.data.defaultCurrency || 'USD')
      form.setFieldValue('currency', res.data.defaultCurrency || 'USD')
    }).catch(() => {
      setCurrencyOptions([{ code: 'USD', label: 'USD' }, { code: 'CNY', label: 'CNY' }, { code: 'HKD', label: 'HKD' }])
    })
  }, [form])

  const handleSubmit = async (values: ProductForm) => {
    setLoading(true)
    try {
      await createProduct({
        ...values,
        price: String(values.price),
        productType: 'ONE_TIME',
      })
      message.success('產品創建成功')
      navigate('/dashboard/products')
    } catch (error: unknown) {
      message.error(error instanceof Error ? error.message : '創建失敗')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <Title level={4} style={{ marginBottom: 24 }}>創建產品</Title>
      <Card style={{ maxWidth: 600 }}>
        <Form form={form} layout="vertical" onFinish={handleSubmit} initialValues={{ currency: defaultCurrency }}>
          <Form.Item name="name" label="產品名稱" rules={[{ required: true, message: '請輸入產品名稱' }]}>
            <Input placeholder="例如：Pro 服務" />
          </Form.Item>
          <Form.Item name="description" label="產品描述"><TextArea rows={4} placeholder="產品描述（可選）" /></Form.Item>
          <Form.Item name="price" label="價格" rules={[{ required: true, message: '請輸入價格' }]}>
            <InputNumber min={0.01} step={0.01} precision={2} style={{ width: '100%' }} placeholder="9.99" addonAfter={
              <Form.Item name="currency" noStyle><Select style={{ width: 80 }} options={currencyOptions.map((c) => ({ value: c.code, label: c.label }))} /></Form.Item>
            } />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} style={{ marginRight: 8 }} data-testid="product-submit">創建產品</Button>
            <Button onClick={() => navigate('/dashboard/products')}>取消</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}
